import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Result, Typography } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function LivenessCallback() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  const groupId = searchParams.get('group_id');

  if (status === 'success') {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f7f8fa' }}>
        <Result
          icon={<CheckCircleOutlined style={{ color: '#52c41a', fontSize: 64 }} />}
          title={<Text style={{ fontSize: 22, fontWeight: 600, color: '#1a1a1a' }}>Verification Successful</Text>}
          subTitle={
            <div style={{ marginTop: 8 }}>
              <Text type="secondary" style={{ display: 'block' }}>
                Your identity has been verified{groupId ? <> — group <Text code>{groupId}</Text></> : ''}.
              </Text>
              <Text type="secondary" style={{ display: 'block', marginTop: 4 }}>
                You may now return to your computer to continue creating.
              </Text>
            </div>
          }
        />
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f7f8fa' }}>
      <Result
        icon={<CloseCircleOutlined style={{ color: '#ff4d4f', fontSize: 64 }} />}
        title={<Text style={{ fontSize: 22, fontWeight: 600, color: '#1a1a1a' }}>Verification Failed</Text>}
        subTitle={
          <Text type="secondary">
            The liveness check could not be completed. Please return to your computer and try again.
          </Text>
        }
      />
    </div>
  );
}
